export class AppConstants {

  //file upload validations
  public static readonly FileUpload_AllowedExtensionsBizLicns: RegExp = /(\.jpg|\.jpeg|\.png|\.pdf|\.heic)$/i;
  public static readonly FileUpload_MaxFileSize: number = 5242880; //5MB

  //bank zoho form
  public static readonly Bank_StopPolling: number = 120000; // 2 min
  public static readonly Bank_pollingInterval: number = 2000; // 5 sec

  // Home Address Zoho Form
  public static readonly HomeAddress_StopPolling: number = 60000; // 1 min
  public static readonly HomeAddress_pollingInterval: number = 2000; // 5 sec

  // Service Fee Ids
  public static readonly serviceFee_Monthly: number = 8;
  public static readonly serviceFee_Yearly: number = 9;

  // Subscription Ids
  public static readonly no_pay_nrs_subscriptionId: number = 1;

  public static readonly nrs_pay_subscriptionId: number = 2;

  public static readonly REFRESH_TOKEN_URL: string = '/authenticate/refreshToken';
  public static readonly LOGIN_URL: string = '/authenticate';
  public static readonly CONFIRMATION_LOGIN_URL: string = '/authenticate/confirmation-token';
  public static readonly VERIFY_OTP_URL: string = '/otp-authenticate/verify-otp';

  // Terms
  public static readonly Monthly: number = 1;
  public static readonly Yearly: number = 12;

  // Service Payment Plans
  public static readonly Monthly_Plan: number = 4;
  public static readonly Yearly_Plan: number = 5;

  // Software Features Page Tabs
  public static readonly stand_alone_features: string = 'Add-On Features';
  public static readonly add_on_bundles: string = 'Add-On Bundles';
  public static readonly request_features: string = 'Request Features & Bundles';
  public static readonly request_add_on_bundles: string = 'Request Add-On Bundles';

  public static readonly PAYMENT_PLAN_MONTHLY: string = 'Monthly Plan';
  public static readonly PAYMENT_PLAN_YEARLY: string = 'Yearly Plan';


  public static readonly MONTHLY_PAYMENT_PLAN_ID: number = 4;
  public static readonly YEARLY_PAYMENT_PLAN_ID: number = 5;
  public static readonly UPFRONT_PAYMENT_PLAN_ID: number = 1;
  public static readonly CUSTOM_PAYMENT_PLAN_ID: number = 3;

  public static readonly UPFRONT_PLAN: string = 'Upfront Plan';
  public static readonly CUSTOM_PLAN: string = 'Custom';
  public static readonly DOWN_PLAN: string = '499 Down Plan';
  public static readonly HARDWARE_SALE_PLAN: string = 'hardware sale plan';
  public static readonly MONTHLY_PLAN_TEXT: string = 'Monthly Plan';
  public static readonly YEARLY_PLAN_TEXT: string = 'Yearly Plan';

  public static readonly PAYMENT_LOAN_INTEREST_VALUE: number = 5;

  public static readonly NRSPAY_SUITE_NAME = 'NRS PAY ONLY';

  public static readonly NRSPAY_CATEGORY = 'NRS Pay';
 //ToolTip for All Pages
 public static readonly TOOLTIP_TEXT: string = `
 By checking the box and submitting this information, you agree to our privacy policy and terms, and consent to NRS contacting you by email, direct dial and/or text message using an automated system or prerecorded voice to discuss NRS’s products and services. Consent is not required for service, and you may opt out at any time. Message and data rates may apply. Message frequency varies.
`;
  // Subscription type ids and names
  public static readonly classic_pos: number = 1;
  public static readonly classic_pos_nrspay: number = 2;
  public static readonly panther_nrspay: number = 57;
  public static readonly nrspay: number = 67;
  public static readonly pos_cash_discount: number = 18;
  public static readonly panther_cash_discount: number = 79;

  public static readonly classic_pos_name: string = 'POS+';
  public static readonly classic_pos_nrspay_name: string = 'POS+NRSPAY';
  public static readonly panther_nrspay_name: string = 'PANTHER';
  public static readonly nrspay_name: string = 'NRSPAY';
  public static readonly pos_cash_discount_name= 'POS+Cash Discount';
  public static readonly panther_cash_discount_name= 'Panther+Cash Discount';
  public static readonly nrspay_features: string = 'NRS Pay Services'

  // Keyed by hardware bundle id (ids are identical across environments; names are not stable).
  public static readonly BUNDLE_DISPLAY: Readonly<Record<number, { title: string; image: string }>> = {
    [AppConstants.classic_pos]: { title: 'Countertop POS', image: 'classic_pos' },
    [AppConstants.classic_pos_nrspay]: { title: 'Countertop POS', image: 'classic_pos_nrs_pay' },
    [AppConstants.pos_cash_discount]: { title: 'Countertop POS', image: 'classic_pos_nrs_pay' },
    [AppConstants.panther_nrspay]: { title: 'Panther POS', image: 'panther_nrs_pay' },
    [AppConstants.panther_cash_discount]: { title: 'Panther POS', image: 'panther_nrs_pay' },
    [AppConstants.nrspay]: { title: 'NRS Pay', image: 'nrs_pay' },
  };

  public static readonly Basic: string = 'Basic';
  public static readonly Pro: string = 'Pro';
  public static readonly Advanced: string = 'Advanced';
  public static readonly Elite: string = 'Elite';

  // NRS Pay Features
  public static readonly unlimitedEBT : number = 50;
  public static readonly eWIC : number = 109;
  public static readonly unlimitedEBTAndEWIC : number = 187;


  public static ORDER_STATUS=[
    {
      "description":"DRAFT",
      "status":"1"
    },
    {
       "description":"PENDING_CONTRACTOR_SIGN",
       "status":"11"
    }
  ]

  public static kindOfBusinessList = [
    { kindOfBusiness: 'Bakery', avg_ticket: '', highest_ticket: '200' },
    { kindOfBusiness: 'Beauty Salon or Barber Shop', avg_ticket: '', highest_ticket: '300' },
    { kindOfBusiness: 'Bodega, Convenience Store or Mini Mart', avg_ticket: '', highest_ticket: '300' },
    { kindOfBusiness: 'Cash & Carry or Wholesale', avg_ticket: '', highest_ticket: '200' },
    { kindOfBusiness: 'Car Wash', avg_ticket: '', highest_ticket: '400' },
    { kindOfBusiness: 'Auto Repair', avg_ticket: '', highest_ticket: '750' },
    { kindOfBusiness: 'Clothing or Footwear', avg_ticket: '', highest_ticket: '400' },
    // {kindOfBusiness: 'Cultural Food Market', avg_ticket: '1-20', highest_ticket: '200'},
    // {kindOfBusiness: 'Deli Grocery', avg_ticket: '1-20', highest_ticket: '200'},
    // {kindOfBusiness: 'Cannabis Dispensary', avg_ticket: '1-20', highest_ticket: '200'},
    { kindOfBusiness: 'Dollar Store, Variety Store or Discount Store', avg_ticket: '', highest_ticket: '300' },
    { kindOfBusiness: 'Fruit or Produce Store', avg_ticket: '', highest_ticket: '300' },
    // {kindOfBusiness: 'Gas Station Convenience Store', avg_ticket: '20-50', highest_ticket: '300'},
    { kindOfBusiness: 'Hardware', avg_ticket: '', highest_ticket: '4800' },
    { kindOfBusiness: 'Laundromat', avg_ticket: '', highest_ticket: '300' },
    { kindOfBusiness: 'Meat Market, Carniceria or Seafood Store', avg_ticket: '', highest_ticket: '400' },
    // {kindOfBusiness: 'Multiservices', avg_ticket: '1-20', highest_ticket: '200'},
    { kindOfBusiness: 'Pharmacy', avg_ticket: '', highest_ticket: '300' },
    { kindOfBusiness: 'Restaurant or Pizzeria', avg_ticket: '', highest_ticket: '400' },
    // {kindOfBusiness: 'Stationery Store', avg_ticket: '1-20', highest_ticket: '200'},
    { kindOfBusiness: 'Supermarket or Large Grocery Store', avg_ticket: '', highest_ticket: '500' },
    { kindOfBusiness: 'Tobacco or Smoke Shop', avg_ticket: '', highest_ticket: '400' },
    { kindOfBusiness: 'Wine and Liquor', avg_ticket: '', highest_ticket: '500' },
    { kindOfBusiness: 'Phone or Electronic Store', avg_ticket: '', highest_ticket: '500' },
    { kindOfBusiness: 'Accounting, Notary & Tax Preparation Services', avg_ticket: '', highest_ticket: '500' },
    { kindOfBusiness: 'Other' },
  ];


  public static readonly PANTHER_TERMINAL_DEFAULT:string='Panther Bring Your Own Device';
  public static readonly TYPE_ADDITIONAL_BUNDLE:string='A';
  public static readonly ACTION_AGREEMENT_SIGNED:string='signed';
  public static readonly ACTION_AGREEMENT_GETSIGNATURE:string='getsignature';

  public static ACCOUNT_PORTAL_ORDER_STATUS_MAPPING = {
    "Complete": "Complete",
    "complete-shipped": "Shipped",
    "Installation": "Installation Stage",
    "POS Canceled": "Order Cancelled",
    "Rejected": "Order Cancelled",
    "Pending NRS Pay Approval": "Pending NRS Pay Approval",
    "Pending AR Approval": "Pending AR Approval",
  }

  public static readonly PROMOTION_FEATURE:string='F';
  public static readonly PROMOTION_ADDITIONAL_BUNDLE:string='A';

  public static readonly ADDITIONAL_BUNDLE:string='A';

  public static readonly PRODUCT_ID:number=1;


  public static readonly NRS_PAY_CASH_DISCOUNT= 'NRS Pay Cash Discount';

  public static readonly NRS_PAY_CLEAN_RATE= 'NRS Pay Clean Rate';

  public static readonly RAPID_SAME_DAY_FUNDING ='Rapid Same Day Funding (Billed Separately)';


  public static SWITCH_TO_HARDWARE_BUNDLE=[
    {
        "FromBundleId":2,
        "ToBundleId":18,
        "ToBundleDescription":"POS+Cash Discount",
        "FromBundleDescription":"POS+NRSPAY"
    },
    {
        "FromBundleId":57,
        "ToBundleId":79,
        "ToBundleDescription":"Panther+Cash Discount",
        "FromBundleDescription":"PANTHER"
    }];
  public static SWITCH_TO_SOFTWARE_BUNDLE=[
    {
      "FromBundleId":5,
      "ToBundleId":19
    },
    {
      "FromBundleId":7,
      "ToBundleId":20
    },
    {
      "FromBundleId":9,
      "ToBundleId":21
    },
    {
      "FromBundleId":71,
      "ToBundleId":72
    }];

  public static readonly HARDWARE_BUNDLE_TYPE='H';

  public static readonly SOFTWARE_BUNDLE_TYPE='S';

  public static readonly NRSPAY_BUNDLE_TYPE='N';


  public static readonly MONTHLY_IN_TEXT = 'MONTHLY';
  public static readonly YEARLY_IN_TEXT = 'YEARLY';

  public static readonly SERVICES='Services';

  public static readonly MAX_QTY : number = 15;

  public static readonly ONLINE_MARKETING_BUNDLE_FEE_ITEM_ID : number =149;


  public static NRSPAY_PRICING_PLAN_TEXT=[
    {
      "Description":"NRS Pay Clean Rate",
      "value":"Standard Rate"
    },
    {
      "Description":"NRS Pay Cash Discount",
      "value":"Cash Discount"
    }];


  public  static readonly PREMIUM_SCANNER_BILLING_ITEM = 238;
  public  static readonly HANDHELD_SCANNER_BILLING_ITEM = 83;

  public static readonly  SCANNER_REQUIRED_TERMINAL_ITEMS = new Set([1, 68, 67, 204, 225,206]);

  public static readonly  CREATE_ORDER_FLOW="Create";

}
